import React from 'react';
import { Button, Tooltip } from 'antd';
import { ButtonToolbarWrapperProps } from './page-toolbar.entity';
import { AntdIconWrapper } from './icon-toolbar-wrapper';

export function ButtonToolbarWrapper(props: ButtonToolbarWrapperProps) {
  const {
    hidden = false,
    tooltipTitle = '',
    showSeparator = true,
    separatorPlacement = 'left',
    buttonStyle,
    handleClick,
    buttonTitle,
    loadingButton,
    icon,
    disabled = false,
    children,
  } = props;

  const defaultButtonStyle = {
    marginLeft: '12px',
    marginRight: '12px',
    fontSize: '12px',
  };
  if (hidden) return <React.Fragment></React.Fragment>;
  return (
    <div className="page-toolbar-content-button">
      {showSeparator && separatorPlacement === 'left' && (
        <div className="separator-toolbar-content"></div>
      )}
      <Tooltip placement="bottom" title={tooltipTitle}>
        <Button
          type="text"
          shape="circle"
          disabled={disabled}
          onClick={handleClick}
          loading={loadingButton}
          style={buttonStyle ?? defaultButtonStyle}
          icon={icon ? <AntdIconWrapper>{icon}</AntdIconWrapper> : undefined}
        >
          {buttonTitle}
          {children ? children : <></>}
        </Button>
      </Tooltip>
      {showSeparator && separatorPlacement === 'right' && (
        <div className="separator-toolbar-content"></div>
      )}
    </div>
  );
}
